// import React, { useMemo, useState, useEffect, useCallback } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS, CategoryScale, LinearScale,
//   BarElement, Tooltip, Legend,
// } from "chart.js";
// import { useDispatch, useSelector } from "react-redux";
// import SuggestionModal from "./suggestionModal";
// import "./report.scss";
// import { analyticsReport } from "../../../../Redux/analytics/analytics.action";
// import { getUserList } from "../../../../Redux/authentication/auth.action";
// import { reportData } from "../../../../Redux/Teacher_Panel/report/report.action";
// import { useNavigate } from "react-router-dom";
// import Loader from "../../../../utils/loader/loader";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// const PALETTE = {
//   Mathematics:        { solid: "#f97316", light: "#fff3e8", text: "#c2410c" },
//   Physics:            { solid: "#8b5cf6", light: "#f3f0ff", text: "#6d28d9" },
//   Chemistry:          { solid: "#d97706", light: "#fffbeb", text: "#b45309" },
//   Biology:            { solid: "#059669", light: "#ecfdf5", text: "#065f46" },
//   English:            { solid: "#0891b2", light: "#ecfeff", text: "#155e75" },
//   Science:            { solid: "#db2777", light: "#fdf2f8", text: "#9d174d" },
//   "Computer science": { solid: "#2563eb", light: "#eff6ff", text: "#1e40af" },
//   History:            { solid: "#0d9488", light: "#f0fdfa", text: "#115e59" },
//   Geography:          { solid: "#65a30d", light: "#f7fee7", text: "#3f6212" },
//   Hindi:              { solid: "#e11d48", light: "#fff1f2", text: "#9f1239" },
// };
// const FALLBACKS = [
//   { solid:"#7c3aed", light:"#f5f3ff", text:"#4c1d95" },
//   { solid:"#0369a1", light:"#f0f9ff", text:"#0c4a6e" },
//   { solid:"#b45309", light:"#fffbeb", text:"#78350f" },
//   { solid:"#15803d", light:"#f0fdf4", text:"#14532d" },
// ];
// const _dyn = {}; let _fi = 0;
// function pal(sub) {
//   if (PALETTE[sub]) return PALETTE[sub];
//   if (!_dyn[sub]) { _dyn[sub] = FALLBACKS[_fi % FALLBACKS.length]; _fi++; }
//   return _dyn[sub];
// }
// function hex2rgba(hex, a) {
//   const r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
//   return `rgba(${r},${g},${b},${a})`;
// }
// function toPercent(score, max) {
//   if (!max) return 0;
//   return max > 10 ? Math.min(100, Math.round(score)) : Math.min(100, Math.round((score/max)*100));
// }
// function gradeBadge(pct) {
//   if (pct >= 85) return { label: "A+", color: "#059669" };
//   if (pct >= 70) return { label: "A",  color: "#0891b2" };
//   if (pct >= 55) return { label: "B",  color: "#7c3aed" };
//   if (pct >= 40) return { label: "C",  color: "#d97706" };
//   return           { label: "D",  color: "#ef4444" };
// }

// function mkOpts({ yLabel="", yMax, labelFn, clickFn } = {}) {
//   return {
//     responsive: true, maintainAspectRatio: false,
//     animation: { duration: 500, easing: "easeOutQuart" },
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         backgroundColor: "#1e293b", titleColor: "#f8fafc", bodyColor: "#cbd5e1",
//         borderColor: "rgba(255,255,255,0.1)", borderWidth: 1, padding: 12, cornerRadius: 10,
//         callbacks: { label: labelFn || ((ctx) => ` ${ctx.parsed.y}`) },
//       },
//     },
//     scales: {
//       x: {
//         grid: { display: false },
//         ticks: { color: "#94a3b8", font: { size: 11, family:"'DM Sans',sans-serif" }, maxRotation: 30 },
//         border: { display: false },
//       },
//       y: {
//         min: 0, max: yMax,
//         grid: { color: "rgba(0,0,0,0.05)" },
//         ticks: { color: "#94a3b8", font:{ size:10 }, callback: (v) => yLabel ? `${v}${yLabel}` : v },
//         border: { display: false },
//       },
//     },
//     onClick: clickFn,
//   };
// }
// function mkOptsWithLegend(args) { return mkOpts(args); }

// function mkHorizOpts({ xMax = 100, labelFn, clickFn } = {}) {
//   return {
//     indexAxis: "y",
//     responsive: true, maintainAspectRatio: false,
//     animation: { duration: 500, easing: "easeOutQuart" },
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         backgroundColor: "#1e293b", titleColor: "#f8fafc", bodyColor: "#cbd5e1",
//         borderColor: "rgba(255,255,255,0.1)", borderWidth: 1, padding: 12, cornerRadius: 10,
//         callbacks: { label: labelFn || ((ctx) => ` ${ctx.parsed.x}%`) },
//       },
//     },
//     scales: {
//       x: {
//         min: 0, max: xMax,
//         grid: { color: "rgba(0,0,0,0.05)" },
//         ticks: { color: "#94a3b8", font: { size: 10 }, callback: (v) => `${v}%` },
//         border: { display: false },
//       },
//       y: {
//         grid: { display: false },
//         ticks: { color: "#475569", font: { size: 11, family:"'DM Sans',sans-serif" } },
//         border: { display: false },
//       },
//     },
//     onClick: clickFn,
//   };
// }

// function ScoreRing({ score, color, size=64, strokeWidth=7 }) {
//   const r = (size - strokeWidth*2) / 2;
//   const circ = 2 * Math.PI * r;
//   const dash = (score / 100) * circ;
//   return (
//     <svg width={size} height={size} style={{ transform:"rotate(-90deg)" }}>
//       <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={hex2rgba(color,0.15)} strokeWidth={strokeWidth} />
//       <motion.circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color}
//         strokeWidth={strokeWidth} strokeLinecap="round" strokeDasharray={circ}
//         initial={{ strokeDashoffset: circ }} animate={{ strokeDashoffset: circ - dash }}
//         transition={{ duration: 1.1, ease: "easeOut", delay: 0.1 }}
//       />
//       <text x={size/2} y={size/2+1} textAnchor="middle" dominantBaseline="middle"
//         fill="#1e293b" fontSize={size>56?13:10} fontWeight={700}
//         style={{ transform:`rotate(90deg)`, transformOrigin:`${size/2}px ${size/2}px`, fontFamily:"'DM Sans',sans-serif" }}>
//         {score}%
//       </text>
//     </svg>
//   );
// }

// function StatCard({ subject, score, attempts, active, onClick }) {
//   const p = pal(subject);
//   return (
//     <motion.button onClick={onClick} whileHover={{ y: -3 }} whileTap={{ scale: 0.97 }}
//       className={`dlg-stat-card${active ? " dlg-stat-card--active" : ""}`}
//       style={{ background: active ? p.solid : undefined, border: `1.5px solid ${active ? p.solid : "#e2e8f0"}`,
//         boxShadow: active ? `0 8px 24px ${hex2rgba(p.solid, 0.28)}` : undefined }}>
//       <ScoreRing score={
//   score == null
//     ? ""
//     : Number.isInteger(score)
//     ? score
//     : score.toFixed(1)
// } color={active ? "#fff" : p.solid} size={48} strokeWidth={5} />
//       <div>
//         <div className={`dlg-stat-card-label dlg-stat-card-label--${active ? "active" : "inactive"}`}>
//           {subject.length > 14 ? subject.slice(0, 14) + "…" : subject}
//         </div>
//         <div className={`dlg-stat-card-score dlg-stat-card-score--${active ? "active" : "inactive"}`}>{score}%</div>
//         <div className={`dlg-stat-card-attempts dlg-stat-card-attempts--${active ? "active" : "inactive"}`}>
//           {attempts} attempt{attempts !== 1 ? "s" : ""}
//         </div>
//       </div>
//     </motion.button>
//   );
// }

// function ChartCard({ title, subtitle, height=200, accent, children, locked, lockMsg, delay=0, fullRow }) {
//   return (
//     <motion.div className={`dlg-card${fullRow ? " dlg-full-row" : ""}`}
//       initial={{ opacity:0, y:18 }} animate={{ opacity:1, y:0 }}
//       transition={{ duration:0.4, ease:"easeOut", delay }}>
//       {accent && <div className="dlg-card-accent" style={{ background: `linear-gradient(90deg,${accent},${hex2rgba(accent,0)})` }} />}
//       <div className="dlg-card-header">
//         <div className="dlg-card-title">{title}</div>
//         <div className="dlg-card-sub">{subtitle}</div>
//       </div>
//       <div className="dlg-card-body" style={{ height, position: "relative" }}>{children}</div>
//       <AnimatePresence>
//         {locked && (
//           <motion.div className="dlg-card-lock-overlay" initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }}>
//             <div className="dlg-lock-icon">📊</div>
//             <span className="dlg-lock-title">Select a subject</span>
//             <span className="dlg-lock-msg">{lockMsg}</span>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </motion.div>
//   );
// }

// function NoData() {
//   return (
//     <div className="dlg-no-data">
//       <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
//         <path d="M3 3v18h18"/><path d="m7 16 4-4 4 4 4-4"/>
//       </svg>
//       <span className="dlg-no-data-text">No data for this period</span>
//     </div>
//   );
// }

// function ZeroAttemptedBanner({ total }) {
//   return (
//     <div className="dlg-zero-banner">
//       <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
//         <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
//         <line x1="12" y1="16" x2="12.01" y2="16"/>
//       </svg>
//       <span><strong>{total} student{total !== 1 ? "s" : ""} assigned</strong> — no one has attempted the test yet</span>
//     </div>
//   );
// }

// const PERIODS = [
//   { val:"all", label:"All time" }, { val:"today", label:"Today" },
//   { val:"yesterday", label:"Yesterday" }, { val:"week", label:"7 days" },
//   { val:"month", label:"30 days" }, { val:"range", label:"Custom" },
// ];
// function PeriodTabs({ mode, onChange }) {
//   return (
//     <div className="dlg-period-tabs">
//       {PERIODS.map(({ val, label }) => (
//         <button key={val} onClick={() => onChange(val)}
//           className={`dlg-period-tab dlg-period-tab--${mode === val ? "active" : "inactive"}`}>
//           {label}
//         </button>
//       ))}
//     </div>
//   );
// }

// function StudentRow({ rank, name, avgPct, isSelected, onClick, isTop }) {
//   const badge = gradeBadge(avgPct);
//   const barColor = isTop ? "#059669" : "#ef4444";
//   return (
//     <motion.div onClick={onClick} whileHover={{ x: 3 }}
//       style={{ display:"flex", alignItems:"center", gap:10, padding:"7px 10px", borderRadius:8,
//         cursor:"pointer", marginBottom:4,
//         background: isSelected ? hex2rgba(barColor, 0.08) : "transparent",
//         border: `1px solid ${isSelected ? hex2rgba(barColor, 0.3) : "transparent"}` }}>
//       <span style={{ width:24, textAlign:"center", fontWeight:700, fontSize:12, flexShrink:0,
//         color: isTop && rank <= 3 ? ["#f59e0b","#94a3b8","#b45309"][rank-1] : "#94a3b8" }}>
//         {isTop && rank <= 3 ? ["🥇","🥈","🥉"][rank-1] : `#${rank}`}
//       </span>
//       <span style={{ flex:1, fontSize:12, fontWeight:600, color:"#1e293b",
//         whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{name}</span>
//       <div style={{ width:72, height:6, borderRadius:4, background:"#f1f5f9", flexShrink:0 }}>
//         <motion.div initial={{ width:0 }} animate={{ width:`${avgPct}%` }}
//           transition={{ duration:0.7, ease:"easeOut" }}
//           style={{ height:"100%", borderRadius:4, background:barColor }} />
//       </div>
//       <span style={{ fontSize:11, fontWeight:700, color:badge.color,
//         background:hex2rgba(badge.color,0.1), borderRadius:4, padding:"1px 6px", flexShrink:0 }}>
//         {badge.label} {avgPct}%
//       </span>
//     </motion.div>
//   );
// }

// export default function ReportBody() {
//   const dispatch = useDispatch();
//   const nav = useNavigate();
//   const [barThickness, setBarThickness] = useState(28);
//   const [group, setGroup] = useState("All");
//   const [topicNames, setTopicNames] = useState({});
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [maxRawScore, setMaxRawScore] = useState(5);
//   const [section1Filter, setSection1Filter] = useState(null);
//   const [section2Filter, setSection2Filter] = useState(null);
//   const [section3Filter, setSection3Filter] = useState(null);
//   const [showCTAConfirm, setShowCTAConfirm] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState({ title:"", body:null });
//   const [mode, setMode] = useState("all");
//   const [range, setRange] = useState({ start:"", end:"" });
//   const [teacherSubject, setTeacherSubject] = useState(null);
//   const [selectedChapterIdx, setSelectedChapterIdx] = useState(null);
//   const [row3Subject, setRow3Subject] = useState(null);
//   const [selectedStudent, setSelectedStudent] = useState(null);
//   const [studentSubjectFilter, setStudentSubjectFilter] = useState(null);

//   const [loading, setLoading] = useState(false);

//   const analyticsStore  = useSelector((s) => s?.AnalyticsManager?.analyticsReport?.assignments);
//   const reportDataStore = useSelector((s) => s?.reportManager?.reportDataArray?.assignments);

//   useEffect(() => { dispatch(analyticsReport()); }, [dispatch]);
//   useEffect(() => { if (analyticsStore?.length > 0) processData(analyticsStore); }, [analyticsStore]);
//   useEffect(() => { dispatch(getUserList()); }, [dispatch]);
//   useEffect(() => { dispatch(reportData()); }, [dispatch]);

//   useEffect(() => {
//     setRow3Subject(teacherSubject);
//     setSelectedChapterIdx(null);
//   }, [teacherSubject]);

//   function processData(data) {
//     const result = {}; let max = 0;
//     data.forEach((item) => {
//       const sub  = item.subject || "Unknown";
//       const ch   = item.chapters?.[0] || "Unknown";
//       const date = (item.created_date || "").split("T")[0];
//       const score = item.score ?? 0;
//       const time  = item.time_spent_minutes ?? 0;
//       if (score > max) max = score;
//       if (!result[sub]) result[sub] = {};
//       const key = `${ch}_${date}`;
//       if (!result[sub][key]) result[sub][key] = { name:ch, date, score, attempts:1, timeSpent:time };
//       else { result[sub][key].score += score; result[sub][key].attempts++; result[sub][key].timeSpent += time; }
//     });
//     Object.keys(result).forEach((sub) => {
//       result[sub] = Object.values(result[sub]).map((it) => ({ ...it, score: it.score / it.attempts }));
//     });
//     setMaxRawScore(max || 5);
//     setTopicNames(result);
//   }

//   // DATE FILTER FIX: reset all state on period change, fresh empty range for "Custom"
//   useEffect(() => {
//     const today = new Date();
//     const iso = (d) => d.toISOString().split("T")[0];
//     const off = (n) => { const d = new Date(today); d.setDate(today.getDate()+n); return iso(d); };
//     if      (mode==="today")     setRange({ start:iso(today), end:iso(today) });
//     else if (mode==="yesterday") setRange({ start:off(-1), end:off(-1) });
//     else if (mode==="week")      setRange({ start:off(-6), end:iso(today) });
//     else if (mode==="month")     setRange({ start:off(-29), end:iso(today) });
//     else if (mode==="all")       setRange({ start:"", end:"" });
//     else if (mode==="range")     setRange({ start:"", end:"" });
//     setSection1Filter(null); setSection2Filter(null); setSection3Filter(null);
//     setSelectedSubject(null); setGroup("All");
//     setTeacherSubject(null); setSelectedChapterIdx(null);
//     setSelectedStudent(null); setStudentSubjectFilter(null);
//   }, [mode]);

//   // DATE FILTER FIX: filteredReportData applies range to teacher data
//   // const filteredReportData = useMemo(() => {
//   //   if (!reportDataStore?.length) return [];
//   //   const { start, end } = range;
//   //   if (!start || !end) return reportDataStore;
//   //   return reportDataStore.filter((a) => {
//   //     const date = (a.created_date || a.date || "").split("T")[0];
//   //     if (!date) return true;
//   //     return date >= start && date <= end;
//   //   });
//   // }, [reportDataStore, range]);

  
// const filteredReportData = useMemo(() => {
//   if (!reportDataStore?.length) return [];
//   const { start, end } = range;
//   if (!start || !end) return reportDataStore;
//   return reportDataStore.filter((a) => {
//     const date = (a.assigned_date || a.created_date || a.date || "").split("T")[0];
//     if (!date) return true;
//     return date >= start && date <= end;
//   });
// }, [reportDataStore, range]);

//   const filteredTopics = useMemo(() => {
//     const { start, end } = range;
//     const out = {};
//     Object.keys(topicNames).forEach((sub) => {
//       out[sub] = (topicNames[sub]||[])
//         .filter((it) => !start||!end||(it.date>=start&&it.date<=end))
//         .map((it) => ({
//           topic: it.name, score: it.score,
//           scoreDisplay: toPercent(it.score, maxRawScore),
//           attempts: it.attempts,
//           timeSpent: parseFloat(it.timeSpent.toFixed(1)),
//           date: it.date, subject: sub,
//         }));
//     });
//     return out;
//   }, [topicNames, range, maxRawScore]);

//   const subjectsAgg = useMemo(() =>
//     Object.keys(filteredTopics).map((sub) => {
//       const list = filteredTopics[sub]||[];
//       if (!list.length) return null;
//       const avgRaw = list.reduce((s,it)=>s+it.score,0)/list.length;
//       return { subject: sub, score: toPercent(avgRaw,maxRawScore),
//         attempts: list.reduce((s,it)=>s+it.attempts,0),
//         timeSpent: parseFloat(list.reduce((s,it)=>s+it.timeSpent,0).toFixed(1)) };
//     }).filter(Boolean),
//   [filteredTopics, maxRawScore]);

//   const topicsFlat = useMemo(() => Object.values(filteredTopics).flat(), [filteredTopics]);
//   const overallScore = useMemo(() => {
//     if (!subjectsAgg.length) return 0;
//     return Math.round(subjectsAgg.reduce((s,it)=>s+it.score,0)/subjectsAgg.length);
//   }, [subjectsAgg]);
//   const selectedScore = useMemo(() =>
//     group==="All" ? null : (subjectsAgg.find((s)=>s.subject===group)?.score ?? null),
//   [subjectsAgg, group]);
//   const topicsFor = useCallback((filter) =>
//     (!filter||filter==="All") ? topicsFlat : topicsFlat.filter((t)=>t.subject===filter),
//   [topicsFlat]);

//   function onSubjectClick(elements, origLabels) {
//     if (!elements.length) return;
//     const sub = origLabels[elements[0].index];
//     if (selectedSubject===sub) {
//       setSelectedSubject(null); setGroup("All");
//       setSection1Filter(null); setSection2Filter(null); setSection3Filter(null);
//     } else {
//       setSelectedSubject(sub); setGroup(sub);
//       setSection1Filter(sub); setSection2Filter(sub); setSection3Filter(sub);
//     }
//   }

//   function confirmCTA() {
//     setShowCTAConfirm(false);
//     setModalContent({ title:"Suggested Plan", body:(
//       <div>
//         <p style={{ marginTop:0 }}>Personalised plan for <strong>{group}</strong>:</p>
//         <ul><li>Short videos + 2 practice sets</li><li>Daily 20-min focused practice</li><li>Weekly 15-min review quiz</li></ul>
//         <button onClick={()=>setModalOpen(false)} style={{ padding:"9px 18px", borderRadius:8, background:"#2563eb", color:"#fff", border:"none", cursor:"pointer", fontWeight:600 }}>Close</button>
//       </div>
//     )});
//     setModalOpen(true);
//   }

//   const totalAttempts = subjectsAgg.reduce((s,it)=>s+it.attempts,0);
//   const totalTime = subjectsAgg.reduce((s,it)=>s+it.timeSpent,0).toFixed(0);
//   const activeSubjectAgg = group !== "All" ? subjectsAgg.find((s) => s.subject === group) : null;
//   const CHIPS = [
//     { label: group!=="All" ? group : "Overall",
//       value: `${group!=="All" ? (selectedScore ?? overallScore) : overallScore}%`, icon:"🎯", colorMod:"blue" },
//     { label:"Attempts", value: group!=="All" ? (activeSubjectAgg?.attempts ?? 0) : totalAttempts, icon:"📝", colorMod:"green" },
//     { label:"Minutes",  value: group!=="All" ? (activeSubjectAgg?.timeSpent?.toFixed(0) ?? 0) : totalTime, icon:"⏱", colorMod:"amber" },
//   ];

//   const teacherSubjectData = useMemo(() => {
//     if (!filteredReportData?.length) return [];
//     const map = {};
//     filteredReportData.forEach((a) => {
//       const sub = a.subject || "Unknown";
//       if (!map[sub]) map[sub] = { subject: sub, assigned: 0, attempted: 0 };
//       map[sub].assigned  += a.no_of_students_assigned  || 0;
//       map[sub].attempted += a.no_of_students_attempted || 0;
//     });
//     return Object.values(map);
//   }, [filteredReportData]);

//   const allZeroAttempted = useMemo(
//     () => teacherSubjectData.length > 0 && teacherSubjectData.every((d) => d.attempted === 0),
//     [teacherSubjectData]);
//   const totalAssignedAcrossAll = useMemo(
//     () => teacherSubjectData.reduce((s, d) => s + d.assigned, 0),
//     [teacherSubjectData]);

//   const allChaptersAvgScore = useMemo(() => {
//     if (!filteredReportData?.length) return [];
//     return filteredReportData
//       .filter((a) => !teacherSubject || a.subject === teacherSubject)
//       .map((a) => {
//         const students = (a.student_details || []).filter((s) => s.percentage != null);
//         const avgPct = students.length
//           ? Math.round(students.reduce((s, st) => s + (st.percentage || 0), 0) / students.length) : 0;
//         return { chapter: a.chapter||"Unknown", subject: a.subject||"Unknown", avgScore: avgPct,
//           attempted: a.no_of_students_attempted||0, assigned: a.no_of_students_assigned||0 };
//       });
//   }, [filteredReportData, teacherSubject]);

//   const allChaptersMarksData = useMemo(() => {
//     if (!filteredReportData?.length) return [];
//     return filteredReportData
//       .filter((a) => !teacherSubject || a.subject === teacherSubject)
//       .map((a) => {
//         const students = (a.student_details || []).filter((s) => s.marks_obtained != null);
//         const marks = students.map((s) => s.marks_obtained);
//         const maxMarks = students[0]?.max_marks ?? null;
//         return {
//           chapter: a.chapter||"Unknown", subject: a.subject||"Unknown",
//           avgMark: marks.length ? parseFloat((marks.reduce((s,m)=>s+m,0)/marks.length).toFixed(1)) : 0,
//           maxMarks, attempted: a.no_of_students_attempted||0, assigned: a.no_of_students_assigned||0,
//           noData: marks.length === 0,
//           students: students.map((s, i) => ({
//             name: s.student_name||s.name||`Student ${i+1}`,
//             marks: s.marks_obtained??0,
//             percentage: s.percentage??(maxMarks?Math.round((s.marks_obtained/maxMarks)*100):0),
//           })),
//         };
//       });
//   }, [filteredReportData, teacherSubject]);

//   const selectedChapterData = useMemo(
//     () => selectedChapterIdx != null ? allChaptersMarksData[selectedChapterIdx] : null,
//     [selectedChapterIdx, allChaptersMarksData]);

//   const SCORE_BUCKETS     = ["0–10","10–20","20–30","30–40","40–50","50–60","60–70","70–80","80–90","90–100"];
//   const BUCKET_COLORS     = ["#ef4444","#f97316","#f59e0b","#eab308","#84cc16","#22c55e","#10b981","#06b6d4","#3b82f6","#8b5cf6"];
//   const BUCKET_COLORS_DIM = BUCKET_COLORS.map((c) => hex2rgba(c, 0.18));

//   const histogramData = useMemo(() => {
//     const buckets = Array(10).fill(0);
//     if (!selectedChapterData) return buckets;
//     (selectedChapterData.students || []).forEach((s) => {
//       buckets[Math.min(Math.floor((s.percentage??0) / 10), 9)]++;
//     });
//     return buckets;
//   }, [selectedChapterData]);

//   const row3SubjectList = useMemo(() => {
//     if (!filteredReportData?.length) return [];
//     const map = {};
//     filteredReportData.forEach((a) => {
//       const sub = a.subject||"Unknown";
//       if (!map[sub]) map[sub] = { subject:sub, chapters:0, assigned:0, attempted:0 };
//       map[sub].chapters++; map[sub].assigned+=a.no_of_students_assigned||0; map[sub].attempted+=a.no_of_students_attempted||0;
//     });
//     return Object.values(map);
//   }, [filteredReportData]);

//   const row3ChapterList = useMemo(() => {
//     if (!row3Subject || !filteredReportData?.length) return [];
//     return filteredReportData.filter((a) => a.subject === row3Subject).map((a) => {
//       const students = (a.student_details||[]).filter((s) => s.marks_obtained != null);
//       const marks = students.map((s) => s.marks_obtained);
//       const pcts  = students.map((s) => s.percentage??(a.max_marks?Math.round((s.marks_obtained/a.max_marks)*100):0));
//       const maxMarks = students[0]?.max_marks ?? null;
//       return {
//         chapter: a.chapter||"Unknown",
//         highest: marks.length ? Math.max(...marks) : null,
//         lowest:  marks.length ? Math.min(...marks) : null,
//         avgMark: marks.length ? parseFloat((marks.reduce((s,m)=>s+m,0)/marks.length).toFixed(1)) : 0,
//         maxMarks, attempted: a.no_of_students_attempted||0, assigned: a.no_of_students_assigned||0,
//         noData: marks.length === 0,
//       };
//     });
//   }, [row3Subject, filteredReportData]);

//   // ── Student Performance ────────────────────────────────────────────────────
//   const studentPerformance = useMemo(() => {
//     if (!filteredReportData?.length) return [];
//     const map = {};
//     filteredReportData.forEach((a) => {
//       const sub = a.subject||"Unknown";
//       const ch  = a.chapter||"Unknown";
//       const maxM = a.student_details?.[0]?.max_marks ?? a.max_marks ?? null;
//       (a.student_details||[]).forEach((s) => {
//         if (s.marks_obtained == null && s.percentage == null) return;
//         const name = s.student_name||s.name||"Unknown";
//         const pct  = s.percentage??(maxM?Math.round((s.marks_obtained/maxM)*100):0);
//         if (!map[name]) map[name] = { name, totalPct:0, count:0, subjects:{} };
//         if (!map[name].subjects[sub]) map[name].subjects[sub] = { avgPct:0, count:0, chapters:[] };
//         map[name].subjects[sub].chapters.push({ chapter:ch, marks:s.marks_obtained??0, maxMarks:s.max_marks??maxM??0, percentage:pct });
//         map[name].subjects[sub].avgPct += pct;
//         map[name].subjects[sub].count++;
//         map[name].totalPct += pct;
//         map[name].count++;
//       });
//     });
//     return Object.values(map).map((st) => {
//       const avgPct = st.count ? Math.round(st.totalPct/st.count) : 0;
//       const subjectList = Object.entries(st.subjects).map(([sub, d]) => ({
//         subject: sub, avgPct: Math.round(d.avgPct/d.count),
//         chapters: d.chapters.sort((a,b) => a.percentage-b.percentage),
//       }));
//       return { ...st, avgPct, subjectList };
//     }).sort((a,b) => b.avgPct-a.avgPct);
//   }, [filteredReportData]);

// //  const topStudents  = useMemo(() => studentPerformance.slice(0, 8),  [studentPerformance]);
// // const weakStudents = useMemo(() => {
// //   const topNames = new Set(topStudents.map((s) => s.name));
// //   const remaining = studentPerformance.filter((s) => !topNames.has(s.name));
// //   const below = remaining.filter((s) => s.avgPct < 50);
// //   return (below.length ? below : remaining.slice(-8)).slice(0,8).reverse();
// // }, [studentPerformance, topStudents]);

// const topStudents  = useMemo(
//   () => studentPerformance.filter((s) => s.avgPct >= 50).slice(0, 8),
//   [studentPerformance]
// );
// const weakStudents = useMemo(() => {
//   const topNames = new Set(topStudents.map((s) => s.name));
//   const remaining = studentPerformance.filter((s) => !topNames.has(s.name));
//   const below = remaining.filter((s) => s.avgPct < 50);
//   return (below.length ? below : remaining.slice(-8)).slice(0,8).reverse();
// }, [studentPerformance, topStudents]);

//   const selectedStudentData = useMemo(
//     () => studentPerformance.find((s) => s.name === selectedStudent) ?? null,
//     [selectedStudent, studentPerformance]);

//   const selectedStudentSubjectChart = useMemo(() =>
//     selectedStudentData ? selectedStudentData.subjectList : null,
//     [selectedStudentData]);

//   const selectedStudentChapterChart = useMemo(() => {
//     if (!selectedStudentData || !studentSubjectFilter) return null;
//     return selectedStudentData.subjectList.find((s) => s.subject === studentSubjectFilter)?.chapters ?? null;
//   }, [selectedStudentData, studentSubjectFilter]);

//   function NoReportAvailable({ mode }) {
//   const periodText = {
//     all: "for any period",
//     today: "for today",
//     yesterday: "for yesterday",
//     week: "for the last 7 days",
//     month: "for the last 30 days",
//     range: "for the selected date range",
//   }[mode] || "";

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }}
//       style={{
//         display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
//         gap: 10, padding: "60px 20px", textAlign: "center",
//       }}
//     >
//       <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.2">
//         <path d="M3 3v18h18" /><path d="m7 16 4-4 4 4 4-4" />
//       </svg>
//       <div style={{ fontSize: 16, fontWeight: 700, color: "#334155" }}>No report available</div>
//       <div style={{ fontSize: 13, color: "#94a3b8", maxWidth: 320 }}>
//         There's no assignment data {periodText}. Try selecting a different period or check back after assigning tests.
//       </div>
//     </motion.div>
//   );
// }

//   return (
//     <div className="dlg-wrapper">

//       <motion.div className="dlg-page-header"
//         initial={{ opacity:0, y:-10 }} animate={{ opacity:1, y:0 }} transition={{ duration:0.35 }}>
//         <div>
//           <h1 className="dlg-page-title">Report Board</h1>
//           <p className="dlg-page-subtitle">Your learning analytics at a glance</p>
          
//         </div>
//           <div className="dlg-modal-actions">
//                 <button className="dlg-modal-confirm" onClick={()=>nav("/report-detailed-view")}>Detailed View</button>
//               </div>
//       </motion.div>

//       <motion.div className="dlg-controls" initial={{ opacity:0 }} animate={{ opacity:1 }} transition={{ delay:0.1 }}>
//         <PeriodTabs mode={mode} onChange={setMode} />
//         {mode === "range" && (
//           <div className="dlg-date-range">
//             <input type="date" value={range.start}
//               onChange={(e) => setRange((p) => ({ ...p, start: e.target.value }))} className="dlg-date-input" />
//             <span className="dlg-date-range-sep">—</span>
//             <input type="date" value={range.end}
//               onChange={(e) => setRange((p) => ({ ...p, end: e.target.value }))} className="dlg-date-input" />
//           </div>
//         )}
//         <div className="dlg-controls-right">
//           <span className="dlg-bar-width-label">Bar width</span>
//           <input type="range" min="10" max="60" step="2" value={barThickness}
//             onChange={(e) => setBarThickness(Number(e.target.value))} className="dlg-range" />
//           <span className="dlg-bar-width-value">{barThickness}px</span>
//         </div>
//       </motion.div>

//       {subjectsAgg.length > 0 && (
//         <motion.div className="dlg-stat-cards"
//           initial={{ opacity:0, y:8 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.15 }}>
//           {subjectsAgg.map((s) => (
//             <StatCard key={s.subject} subject={s.subject} score={s.score} attempts={s.attempts}
//               active={selectedSubject === s.subject}
//               onClick={() => onSubjectClick([{ index: subjectsAgg.indexOf(s) }], subjectsAgg.map((x) => x.subject))}
//             />
//           ))}
//           {selectedSubject && (
//             <motion.button className="dlg-clear-btn" initial={{ opacity:0 }} animate={{ opacity:1 }}
//               onClick={() => { setSelectedSubject(null); setGroup("All"); setSection1Filter(null); setSection2Filter(null); setSection3Filter(null); }}>
//               ✕ Clear
//             </motion.button>
//           )}
//         </motion.div>
//       )}

//       {filteredReportData?.length > 0 ? (
//         <motion.div initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.5 }}>

//           <div className="dlg-section-heading">
//             <div className="dlg-section-dot" />
           
//             <span className="dlg-section-meta"> Total assignments :
           
//                {filteredReportData.length}
//               {teacherSubject && (<>
//                 {" · "}<span style={{ color: pal(teacherSubject).solid, fontWeight:600 }}>{teacherSubject}</span>{" "}
//                 <button onClick={() => setTeacherSubject(null)}
//                   style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8", fontSize:12 }}>✕</button>
//               </>)}
//             </span>
//           </div>

//           {/* ROW 1 */}
//           <div className="dlg-grid mb-5">
//             <ChartCard title="Students Attempted per Subject"
//               subtitle={allZeroAttempted ? "⚠ No students have attempted any test yet"
//                 : "Click a bar to filter all charts below by that subject"}
//               accent="#6366f1" delay={0.52} height={allZeroAttempted ? 160 : 200}>
//               {teacherSubjectData.length === 0 ? <NoData /> : (<>
//                 {allZeroAttempted && <ZeroAttemptedBanner total={totalAssignedAcrossAll} />}
//                 <Bar
//                   data={{
//                     labels: teacherSubjectData.map((d) => d.subject.length>11 ? d.subject.slice(0,11)+"…" : d.subject),
//                     datasets: [{ label:"Attempted", data: teacherSubjectData.map((d) => d.attempted),
//                       backgroundColor: teacherSubjectData.map((d) => { const c=pal(d.subject).solid; return !teacherSubject||d.subject===teacherSubject?c:hex2rgba(c,0.22); }),
//                       hoverBackgroundColor: teacherSubjectData.map((d) => pal(d.subject).solid),
//                       borderRadius:6, borderSkipped:false, barThickness, minBarLength:12 }],
//                   }}
//                   options={mkOpts({
//                     labelFn: (ctx) => { const r=teacherSubjectData[ctx.dataIndex]; return [`Attempted: ${r.attempted}`,`Assigned: ${r.assigned}`]; },
//                     clickFn: (_,els) => { if(!els.length)return; const sub=teacherSubjectData[els[0].index]?.subject; setTeacherSubject(p=>p===sub?null:sub); },
//                   })}
//                 />
//               </>)}
//             </ChartCard>

//             <ChartCard title={teacherSubject ? `${teacherSubject} — Avg Score` : "All Chapters — Avg Score"}
//               subtitle={teacherSubject ? `Chapters for ${teacherSubject} · Hover for details` : "Click a subject bar on the left"}
//               accent="#6366f1" delay={0.56} height={200}
//               locked={!teacherSubject} lockMsg="Click a subject bar on the left">
//               {allChaptersAvgScore.length === 0 ? <NoData /> : (
//                 <Bar
//                   data={{
//                     labels: allChaptersAvgScore.map((d) => d.chapter.length>12?d.chapter.slice(0,12)+"…":d.chapter),
//                     datasets: [{ label:"Avg Score %", data: allChaptersAvgScore.map((d) => d.avgScore),
//                       backgroundColor: allChaptersAvgScore.map((d) => pal(d.subject).solid),
//                       hoverBackgroundColor: allChaptersAvgScore.map((d) => pal(d.subject).solid),
//                       borderRadius:6, borderSkipped:false, barThickness, minBarLength:12 }],
//                   }}
//                   options={mkOpts({ yLabel:"%", yMax:100,
//                     labelFn: (ctx) => { const r=allChaptersAvgScore[ctx.dataIndex]; return [`Avg Score: ${r.avgScore}%`,`Attempted: ${r.attempted}/${r.assigned}`]; },
//                   })}
//                 />
//               )}
//             </ChartCard>
//           </div>

//           {/* AI card */}
//           <motion.div className="dlg-ai-card dlg-full-row mb-5"
//             initial={{ opacity:0, y:16 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.28 }}>
//             <div className="dlg-ai-inner">
//               <div className="dlg-ai-icon">✦</div>
//               <div className="dlg-ai-content">
//                 <div className="dlg-ai-title">AI Insight</div>
//                 <div className="dlg-ai-body">
//                   {group==="All"
//                     ? `Overall score ${overallScore}% across ${subjectsAgg.length} subject${subjectsAgg.length!==1?"s":""}. ${overallScore>=70?"Great progress! Keep the momentum going.":"Consistent daily practice will help push scores higher."}`
//                     : `${group} score is ${selectedScore}%. Focus on weaker topics and reduce time on areas already mastered.`}
//                 </div>
//               </div>
//               <motion.button className="dlg-ai-cta" whileHover={{ scale:1.04 }} whileTap={{ scale:0.97 }}
//                 onClick={() => setShowCTAConfirm(true)}>Explore Course →</motion.button>
//             </div>
//           </motion.div>

//           {/* ROW 2 */}
//           <div className="dlg-grid" style={{ marginTop:0 }}>
//             <ChartCard title={teacherSubject ? `${teacherSubject} — Avg Marks` : "All Chapters — Avg Marks"}
//               subtitle="Click a bar to view score distribution on the right"
//               accent="#f59e0b" delay={0.6} height={200}>
//               {allChaptersMarksData.length === 0 ? <NoData /> : (
//                 <Bar
//                   data={{
//                     labels: allChaptersMarksData.map((d) => d.chapter.length>12?d.chapter.slice(0,12)+"…":d.chapter),
//                     datasets: [{ label:"Avg Marks", data: allChaptersMarksData.map((d) => d.avgMark),
//                       backgroundColor: allChaptersMarksData.map((d) => { const c=pal(d.subject).solid; return d.noData?hex2rgba(c,0.25):c; }),
//                       hoverBackgroundColor: allChaptersMarksData.map((d) => pal(d.subject).solid),
//                       borderRadius:6, borderSkipped:false, barThickness, minBarLength:12 }],
//                   }}
//                   options={mkOpts({
//                     labelFn: (ctx) => { const r=allChaptersMarksData[ctx.dataIndex]; return r.noData?[`No attempts yet`,`Assigned: ${r.assigned}`]:[`Avg Marks: ${r.avgMark}/${r.maxMarks??"?"}`,`Attempted: ${r.attempted}/${r.assigned}`]; },
//                     clickFn: (_,els) => { if(!els.length)return; setSelectedChapterIdx(p=>p===els[0].index?null:els[0].index); },
//                   })}
//                 />
//               )}
//             </ChartCard>

//             <ChartCard title="Score Distribution"
//               subtitle={selectedChapterData ? `"${selectedChapterData.chapter}" — students per score range` : "Click a chapter bar on the left"}
//               accent={selectedChapterData?pal(selectedChapterData.subject).solid:"#f59e0b"}
//               delay={0.64} height={200} locked={!selectedChapterData} lockMsg="Click any chapter bar on the left">
//               {selectedChapterData && (
//                 <Bar
//                   data={{
//                     labels: SCORE_BUCKETS,
//                     datasets: [{ label:"Students", data: histogramData,
//                       backgroundColor: histogramData.map((c,i)=>c===0?BUCKET_COLORS_DIM[i]:BUCKET_COLORS[i]),
//                       hoverBackgroundColor: BUCKET_COLORS,
//                       borderRadius:6, borderSkipped:false, barThickness:Math.min(barThickness,32), minBarLength:12 }],
//                   }}
//                   options={mkOpts({ yMax: Math.max(...histogramData,1),
//                     labelFn: (ctx) => { const c=histogramData[ctx.dataIndex]; const l=SCORE_BUCKETS[ctx.dataIndex]; return c===0?`No students scored ${l}%`:`${c} student${c!==1?"s":""} scored ${l}%`; },
//                   })}
//                 />
//               )}
//             </ChartCard>
//           </div>

//           {/* ROW 3 */}
//           <div className="dlg-section-heading" style={{ marginTop:28 }}>
//             <div className="dlg-section-dot" style={{ background:"#10b981" }} />
//             <h2 className="dlg-section-title">Chapter Score Range</h2>
//             <span className="dlg-section-meta">highest & lowest marks per chapter</span>
//           </div>
//           <div className="dlg-grid">
//             <ChartCard title="Subjects"
//               subtitle={teacherSubject ? `Showing chapters for ${teacherSubject}` : "Click a subject to view chapter-wise ranges"}
//               accent="#10b981" delay={0.68} height={200}>
//               {row3SubjectList.length === 0 ? <NoData /> : (
//                 <Bar
//                   data={{
//                     labels: row3SubjectList.map((d) => d.subject.length>11?d.subject.slice(0,11)+"…":d.subject),
//                     datasets: [{ label:"Chapters", data: row3SubjectList.map((d) => d.chapters),
//                       backgroundColor: row3SubjectList.map((d) => { const c=pal(d.subject).solid; return !row3Subject||d.subject===row3Subject?c:hex2rgba(c,0.25); }),
//                       hoverBackgroundColor: row3SubjectList.map((d) => pal(d.subject).solid),
//                       borderRadius:6, borderSkipped:false, barThickness, minBarLength:12 }],
//                   }}
//                   options={mkOpts({
//                     labelFn: (ctx) => { const r=row3SubjectList[ctx.dataIndex]; return [`Attempted: ${r.attempted}`]; },
//                     clickFn: (_,els) => { if(!els.length)return; const sub=row3SubjectList[els[0].index]?.subject; setRow3Subject(p=>p===sub?null:sub); setTeacherSubject(p=>p===sub?null:sub); },
//                   })}
//                 />
//               )}
//             </ChartCard>

//             <ChartCard title="Chapter Score Range"
//               subtitle={row3Subject ? `${row3Subject} — hover for highest & lowest score` : "Click a subject on the left"}
//               accent={row3Subject?pal(row3Subject).solid:"#10b981"} delay={0.72} height={200}
//               locked={!row3Subject} lockMsg="Click a subject on the left">
//               {row3ChapterList.length === 0 ? <NoData /> : (
//                 <Bar
//                   data={{
//                     labels: row3ChapterList.map((d) => d.chapter.length>14?d.chapter.slice(0,14)+"…":d.chapter),
//                     datasets: [{ label:"Avg Marks", data: row3ChapterList.map((d) => d.avgMark),
//                       backgroundColor: row3ChapterList.map((d) => { const c=row3Subject?pal(row3Subject).solid:"#10b981"; return d.noData?hex2rgba(c,0.2):c; }),
//                       hoverBackgroundColor: row3ChapterList.map(()=>row3Subject?pal(row3Subject).solid:"#10b981"),
//                       borderRadius:6, borderSkipped:false, barThickness, minBarLength:12 }],
//                   }}
//                   options={mkOpts({
//                     labelFn: (ctx) => { const r=row3ChapterList[ctx.dataIndex]; return r.noData?[`No attempts yet`,`Assigned: ${r.assigned}`]:[`Highest: ${r.highest}`,`Lowest: ${r.lowest}`,`Avg: ${r.avgMark}`]; },
//                   })}
//                 />
//               )}
//             </ChartCard>
//           </div>

//           {/* ═══ STUDENT PERFORMANCE INTELLIGENCE ═══ */}
//           {studentPerformance.length > 0 && (<>
//             <div className="dlg-section-heading" style={{ marginTop:32 }}>
//               <div className="dlg-section-dot" style={{ background:"#f59e0b" }} />
//               <h2 className="dlg-section-title">Student Performance</h2>
//               <span className="dlg-section-meta">
//                 {studentPerformance.length} student{studentPerformance.length!==1?"s":""}
//                 {" · "}Click a name to drill down
//                 {selectedStudent && (<>
//                   {" · "}<span style={{ color:"#2563eb", fontWeight:600 }}>{selectedStudent}</span>{" "}
//                   <button onClick={()=>{ setSelectedStudent(null); setStudentSubjectFilter(null); }}
//                     style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8", fontSize:12 }}>✕</button>
//                 </>)}
//               </span>
//             </div>

//             {/* ROW 4 — Top Performers · Needs Attention */}
//             <div className="dlg-grid">
//               <ChartCard title="🏆 Top Performers"
//                 subtitle={`Top ${topStudents.length} students by average score · Click to see breakdown`}
//                 accent="#059669" delay={0.76}
//                 height={Math.max(topStudents.length * 46 + 16, 220)}>
//                 {topStudents.length === 0 ? <NoData /> : (
//                   <div style={{ overflowY:"auto", height:"100%", paddingRight:4 }}>
//                     {topStudents.map((st, i) => (
//                       <StudentRow key={st.name} rank={i+1} name={st.name} avgPct={st.avgPct} isTop
//                         isSelected={selectedStudent===st.name}
//                         onClick={()=>{ setSelectedStudent(p=>p===st.name?null:st.name); setStudentSubjectFilter(null); }} />
//                     ))}
//                   </div>
//                 )}
//               </ChartCard>

//               <ChartCard title="⚠️ Needs Attention"
//                 subtitle={weakStudents.length === 0 ? "All students scoring above 50%!" : `${weakStudents.length} student${weakStudents.length!==1?"s":""} scoring below 50% · Click to investigate`}
//                 accent="#ef4444" delay={0.8}
//                 height={Math.max(weakStudents.length * 46 + 16, 220)}>
//                 {weakStudents.length === 0 ? (
//                   <div className="dlg-no-data">
//                     <span style={{ fontSize:28 }}>🎉</span>
//                     <span className="dlg-no-data-text" style={{ color:"#059669" }}>All students above 50%!</span>
//                   </div>
//                 ) : (
//                   <div style={{ overflowY:"auto", height:"100%", paddingRight:4 }}>
//                     {weakStudents.map((st, i) => (
//                       <StudentRow key={st.name} rank={studentPerformance.length-i} name={st.name} avgPct={st.avgPct} isTop={false}
//                         isSelected={selectedStudent===st.name}
//                         onClick={()=>{ setSelectedStudent(p=>p===st.name?null:st.name); setStudentSubjectFilter(null); }} />
//                     ))}
//                   </div>
//                 )}
//               </ChartCard>
//             </div>

//             {/* ROW 5 — Student Subject Scores · Chapter Marks Drill-down */}
//             <div className="dlg-grid" style={{ marginTop:16 }}>
//               <ChartCard
//                 title={selectedStudent ? `${selectedStudent} — Subject Scores` : "Student Subject Breakdown"}
//                 subtitle={selectedStudent ? "Average % per subject · Click a bar to see chapter marks on the right" : "Click any student above to view subject-wise scores"}
//                 accent="#2563eb" delay={0.84} height={220}
//                 locked={!selectedStudentData} lockMsg="Click a student in the lists above">
//                 {selectedStudentSubjectChart && selectedStudentSubjectChart.length > 0 && (
//                   <Bar
//                     data={{
//                       labels: selectedStudentSubjectChart.map((d) => d.subject),
//                       datasets: [{ data: selectedStudentSubjectChart.map((d) => d.avgPct),
//                         backgroundColor: selectedStudentSubjectChart.map((d) => { const c=pal(d.subject).solid; return !studentSubjectFilter||studentSubjectFilter===d.subject?c:hex2rgba(c,0.25); }),
//                         hoverBackgroundColor: selectedStudentSubjectChart.map((d) => pal(d.subject).solid),
//                         borderRadius:6, borderSkipped:false, barThickness:Math.min(barThickness,40), minBarLength:12 }],
//                     }}
//                     options={mkHorizOpts({
//                       labelFn: (ctx) => { const d=selectedStudentSubjectChart[ctx.dataIndex]; return [`${d.subject}: ${d.avgPct}%`]; },
//                       clickFn: (_,els) => { if(!els.length)return; const sub=selectedStudentSubjectChart[els[0].index]?.subject; setStudentSubjectFilter(p=>p===sub?null:sub); },
//                     })}
//                   />
//                 )}
//               </ChartCard>

//               <ChartCard
//                 title={studentSubjectFilter ? `${selectedStudent} — ${studentSubjectFilter} Chapters` : "Chapter-wise Marks"}
//                 subtitle={studentSubjectFilter ? `Score per chapter · Green ≥75% · Blue ≥50% · Amber ≥35% · Red <35%` : "Click a subject bar on the left to see chapter-level marks"}
//                 accent={studentSubjectFilter?pal(studentSubjectFilter).solid:"#2563eb"}
//                 delay={0.88} height={220}
//                 locked={!studentSubjectFilter} lockMsg="Click a subject bar on the left">
//                 {selectedStudentChapterChart && selectedStudentChapterChart.length > 0 && (
//                   <Bar
//                     data={{
//                       labels: selectedStudentChapterChart.map((d) => d.chapter.length>16?d.chapter.slice(0,16)+"…":d.chapter),
//                       datasets: [{ data: selectedStudentChapterChart.map((d) => d.percentage),
//                         backgroundColor: selectedStudentChapterChart.map((d) =>
//                           d.percentage>=75?"#059669":d.percentage>=50?"#0891b2":d.percentage>=35?"#d97706":"#ef4444"),
//                         hoverBackgroundColor: selectedStudentChapterChart.map(()=>studentSubjectFilter?pal(studentSubjectFilter).solid:"#2563eb"),
//                         borderRadius:6, borderSkipped:false, barThickness:Math.min(barThickness,36), minBarLength:12 }],
//                     }}
//                     options={mkHorizOpts({
//                       labelFn: (ctx) => { const d=selectedStudentChapterChart[ctx.dataIndex]; return [`${d.chapter}`,`Marks: ${d.marks}/${d.maxMarks||"?"} (${d.percentage}%)`]; },
//                     })}
//                   />
//                 )}
//               </ChartCard>
//             </div>
//           </>)}

//         </motion.div>) : <NoReportAvailable mode={mode} />
//       }

//       <AnimatePresence>
//         {showCTAConfirm && (
//           <motion.div className="dlg-modal-backdrop"
//             initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }}
//             onClick={() => setShowCTAConfirm(false)}>
//             <motion.div className="dlg-modal-box"
//               initial={{ scale:0.88, y:20 }} animate={{ scale:1, y:0 }} exit={{ scale:0.88, y:20 }}
//               onClick={(e) => e.stopPropagation()}>
//               <div className="dlg-modal-title">Ready to start?</div>
//               <p className="dlg-modal-body">Open personalised course suggestions for <strong style={{ color:"#1e293b" }}>{group}</strong>.</p>
//               <div className="dlg-modal-actions">
//                 <button className="dlg-modal-confirm" onClick={confirmCTA}>Confirm</button>
//                 <button className="dlg-modal-cancel" onClick={() => setShowCTAConfirm(false)}>Cancel</button>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       <SuggestionModal open={modalOpen} title={modalContent.title} onClose={() => setModalOpen(false)}>
//         {modalContent.body}
//       </SuggestionModal>
//       <Loader show={loading} />
//     </div>
//   );
// }

import React, { useMemo, useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS, CategoryScale, LinearScale,
  BarElement, Tooltip, Legend,
} from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import SuggestionModal from "./suggestionModal";
import "./report.scss";
import { analyticsReport } from "../../../../Redux/analytics/analytics.action";
import { getUserList } from "../../../../Redux/authentication/auth.action";
import { reportData } from "../../../../Redux/Teacher_Panel/report/report.action";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../utils/loader/loader";

import {
  pal,
  hex2rgba,
  toPercent,
  mkOpts,
  mkHorizOpts,
  StatCard,
  ChartCard,
  NoData,
  PeriodTabs,
  ZeroAttemptedBanner,
  StudentRow,
} from "../../../../Reusable_Components/Report";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function ReportBody() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const [barThickness, setBarThickness] = useState(28);
  const [group, setGroup] = useState("All");
  const [topicNames, setTopicNames] = useState({});
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [maxRawScore, setMaxRawScore] = useState(5);
  const [section1Filter, setSection1Filter] = useState(null);
  const [section2Filter, setSection2Filter] = useState(null);
  const [section3Filter, setSection3Filter] = useState(null);
  const [showCTAConfirm, setShowCTAConfirm] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title:"", body:null });
  const [mode, setMode] = useState("all");
  const [range, setRange] = useState({ start:"", end:"" });
  const [teacherSubject, setTeacherSubject] = useState(null);
  const [selectedChapterIdx, setSelectedChapterIdx] = useState(null);
  const [row3Subject, setRow3Subject] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentSubjectFilter, setStudentSubjectFilter] = useState(null);

  const [loading, setLoading] = useState(false);

  const analyticsStore  = useSelector((s) => s?.AnalyticsManager?.analyticsReport?.assignments);
  const reportDataStore = useSelector((s) => s?.reportManager?.reportDataArray?.assignments);

  useEffect(() => { dispatch(analyticsReport()); }, [dispatch]);
  useEffect(() => { if (analyticsStore?.length > 0) processData(analyticsStore); }, [analyticsStore]);
  useEffect(() => { dispatch(getUserList()); }, [dispatch]);
  useEffect(() => { dispatch(reportData()); }, [dispatch]);

  useEffect(() => {
    setRow3Subject(teacherSubject);
    setSelectedChapterIdx(null);
  }, [teacherSubject]);

  function processData(data) {
    const result = {}; let max = 0;
    data.forEach((item) => {
      const sub  = item.subject || "Unknown";
      const ch   = item.chapters?.[0] || "Unknown";
      const date = (item.created_date || "").split("T")[0];
      const score = item.score ?? 0;
      const time  = item.time_spent_minutes ?? 0;
      if (score > max) max = score;
      if (!result[sub]) result[sub] = {};
      const key = `${ch}_${date}`;
      if (!result[sub][key]) result[sub][key] = { name:ch, date, score, attempts:1, timeSpent:time };
      else { result[sub][key].score += score; result[sub][key].attempts++; result[sub][key].timeSpent += time; }
    });
    Object.keys(result).forEach((sub) => {
      result[sub] = Object.values(result[sub]).map((it) => ({ ...it, score: it.score / it.attempts }));
    });
    setMaxRawScore(max || 5);
    setTopicNames(result);
  }

  // DATE FILTER FIX: reset all state on period change, fresh empty range for "Custom"
  useEffect(() => {
    const today = new Date();
    const iso = (d) => d.toISOString().split("T")[0];
    const off = (n) => { const d = new Date(today); d.setDate(today.getDate()+n); return iso(d); };
    if      (mode==="today")     setRange({ start:iso(today), end:iso(today) });
    else if (mode==="yesterday") setRange({ start:off(-1), end:off(-1) });
    else if (mode==="week")      setRange({ start:off(-6), end:iso(today) });
    else if (mode==="month")     setRange({ start:off(-29), end:iso(today) });
    else if (mode==="all")       setRange({ start:"", end:"" });
    else if (mode==="range")     setRange({ start:"", end:"" });
    setSection1Filter(null); setSection2Filter(null); setSection3Filter(null);
    setSelectedSubject(null); setGroup("All");
    setTeacherSubject(null); setSelectedChapterIdx(null);
    setSelectedStudent(null); setStudentSubjectFilter(null);
  }, [mode]);

  const filteredReportData = useMemo(() => {
    if (!reportDataStore?.length) return [];
    const { start, end } = range;
    if (!start || !end) return reportDataStore;
    return reportDataStore.filter((a) => {
      const date = (a.assigned_date || a.created_date || a.date || "").split("T")[0];
      if (!date) return true;
      return date >= start && date <= end;
    });
  }, [reportDataStore, range]);

  const filteredTopics = useMemo(() => {
    const { start, end } = range;
    const out = {};
    Object.keys(topicNames).forEach((sub) => {
      out[sub] = (topicNames[sub]||[])
        .filter((it) => !start||!end||(it.date>=start&&it.date<=end))
        .map((it) => ({
          topic: it.name, score: it.score,
          scoreDisplay: toPercent(it.score, maxRawScore),
          attempts: it.attempts,
          timeSpent: parseFloat(it.timeSpent.toFixed(1)),
          date: it.date, subject: sub,
        }));
    });
    return out;
  }, [topicNames, range, maxRawScore]);

  const subjectsAgg = useMemo(() =>
    Object.keys(filteredTopics).map((sub) => {
      const list = filteredTopics[sub]||[];
      if (!list.length) return null;
      const avgRaw = list.reduce((s,it)=>s+it.score,0)/list.length;
      return { subject: sub, score: toPercent(avgRaw,maxRawScore),
        attempts: list.reduce((s,it)=>s+it.attempts,0),
        timeSpent: parseFloat(list.reduce((s,it)=>s+it.timeSpent,0).toFixed(1)) };
    }).filter(Boolean),
  [filteredTopics, maxRawScore]);

  const topicsFlat = useMemo(() => Object.values(filteredTopics).flat(), [filteredTopics]);
  const overallScore = useMemo(() => {
    if (!subjectsAgg.length) return 0;
    return Math.round(subjectsAgg.reduce((s,it)=>s+it.score,0)/subjectsAgg.length);
  }, [subjectsAgg]);
  const selectedScore = useMemo(() =>
    group==="All" ? null : (subjectsAgg.find((s)=>s.subject===group)?.score ?? null),
  [subjectsAgg, group]);
  const topicsFor = useCallback((filter) =>
    (!filter||filter==="All") ? topicsFlat : topicsFlat.filter((t)=>t.subject===filter),
  [topicsFlat]);

  function onSubjectClick(elements, origLabels) {
    if (!elements.length) return;
    const sub = origLabels[elements[0].index];
    if (selectedSubject===sub) {
      setSelectedSubject(null); setGroup("All");
      setSection1Filter(null); setSection2Filter(null); setSection3Filter(null);
    } else {
      setSelectedSubject(sub); setGroup(sub);
      setSection1Filter(sub); setSection2Filter(sub); setSection3Filter(sub);
    }
  }

  function confirmCTA() {
    setShowCTAConfirm(false);
    setModalContent({ title:"Suggested Plan", body:(
      <div>
        <p style={{ marginTop:0 }}>Personalised plan for <strong>{group}</strong>:</p>
        <ul><li>Short videos + 2 practice sets</li><li>Daily 20-min focused practice</li><li>Weekly 15-min review quiz</li></ul>
        <button onClick={()=>setModalOpen(false)} style={{ padding:"9px 18px", borderRadius:8, background:"#2563eb", color:"#fff", border:"none", cursor:"pointer", fontWeight:600 }}>Close</button>
      </div>
    )});
    setModalOpen(true);
  }

  const totalAttempts = subjectsAgg.reduce((s,it)=>s+it.attempts,0);
  const totalTime = subjectsAgg.reduce((s,it)=>s+it.timeSpent,0).toFixed(0);
  const activeSubjectAgg = group !== "All" ? subjectsAgg.find((s) => s.subject === group) : null;
  const CHIPS = [
    { label: group!=="All" ? group : "Overall",
      value: `${group!=="All" ? (selectedScore ?? overallScore) : overallScore}%`, icon:"🎯", colorMod:"blue" },
    { label:"Attempts", value: group!=="All" ? (activeSubjectAgg?.attempts ?? 0) : totalAttempts, icon:"📝", colorMod:"green" },
    { label:"Minutes",  value: group!=="All" ? (activeSubjectAgg?.timeSpent?.toFixed(0) ?? 0) : totalTime, icon:"⏱", colorMod:"amber" },
  ];

  const teacherSubjectData = useMemo(() => {
    if (!filteredReportData?.length) return [];
    const map = {};
    filteredReportData.forEach((a) => {
      const sub = a.subject || "Unknown";
      if (!map[sub]) map[sub] = { subject: sub, assigned: 0, attempted: 0 };
      map[sub].assigned  += a.no_of_students_assigned  || 0;
      map[sub].attempted += a.no_of_students_attempted || 0;
    });
    return Object.values(map);
  }, [filteredReportData]);

  const allZeroAttempted = useMemo(
    () => teacherSubjectData.length > 0 && teacherSubjectData.every((d) => d.attempted === 0),
    [teacherSubjectData]);
  const totalAssignedAcrossAll = useMemo(
    () => teacherSubjectData.reduce((s, d) => s + d.assigned, 0),
    [teacherSubjectData]);

  const allChaptersAvgScore = useMemo(() => {
    if (!filteredReportData?.length) return [];
    return filteredReportData
      .filter((a) => !teacherSubject || a.subject === teacherSubject)
      .map((a) => {
        const students = (a.student_details || []).filter((s) => s.percentage != null);
        const avgPct = students.length
          ? Math.round(students.reduce((s, st) => s + (st.percentage || 0), 0) / students.length) : 0;
        return { chapter: a.chapter||"Unknown", subject: a.subject||"Unknown", avgScore: avgPct,
          attempted: a.no_of_students_attempted||0, assigned: a.no_of_students_assigned||0 };
      });
  }, [filteredReportData, teacherSubject]);

  const allChaptersMarksData = useMemo(() => {
    if (!filteredReportData?.length) return [];
    return filteredReportData
      .filter((a) => !teacherSubject || a.subject === teacherSubject)
      .map((a) => {
        const students = (a.student_details || []).filter((s) => s.marks_obtained != null);
        const marks = students.map((s) => s.marks_obtained);
        const maxMarks = students[0]?.max_marks ?? null;
        return {
          chapter: a.chapter||"Unknown", subject: a.subject||"Unknown",
          avgMark: marks.length ? parseFloat((marks.reduce((s,m)=>s+m,0)/marks.length).toFixed(1)) : 0,
          maxMarks, attempted: a.no_of_students_attempted||0, assigned: a.no_of_students_assigned||0,
          noData: marks.length === 0,
          students: students.map((s, i) => ({
            name: s.student_name||s.name||`Student ${i+1}`,
            marks: s.marks_obtained??0,
            percentage: s.percentage??(maxMarks?Math.round((s.marks_obtained/maxMarks)*100):0),
          })),
        };
      });
  }, [filteredReportData, teacherSubject]);

  const selectedChapterData = useMemo(
    () => selectedChapterIdx != null ? allChaptersMarksData[selectedChapterIdx] : null,
    [selectedChapterIdx, allChaptersMarksData]);

  const SCORE_BUCKETS     = ["0–10","10–20","20–30","30–40","40–50","50–60","60–70","70–80","80–90","90–100"];
  const BUCKET_COLORS     = ["#ef4444","#f97316","#f59e0b","#eab308","#84cc16","#22c55e","#10b981","#06b6d4","#3b82f6","#8b5cf6"];
  const BUCKET_COLORS_DIM = BUCKET_COLORS.map((c) => hex2rgba(c, 0.18));

  const histogramData = useMemo(() => {
    const buckets = Array(10).fill(0);
    if (!selectedChapterData) return buckets;
    (selectedChapterData.students || []).forEach((s) => {
      buckets[Math.min(Math.floor((s.percentage??0) / 10), 9)]++;
    });
    return buckets;
  }, [selectedChapterData]);

  const row3SubjectList = useMemo(() => {
    if (!filteredReportData?.length) return [];
    const map = {};
    filteredReportData.forEach((a) => {
      const sub = a.subject||"Unknown";
      if (!map[sub]) map[sub] = { subject:sub, chapters:0, assigned:0, attempted:0 };
      map[sub].chapters++; map[sub].assigned+=a.no_of_students_assigned||0; map[sub].attempted+=a.no_of_students_attempted||0;
    });
    return Object.values(map);
  }, [filteredReportData]);

  const row3ChapterList = useMemo(() => {
    if (!row3Subject || !filteredReportData?.length) return [];
    return filteredReportData.filter((a) => a.subject === row3Subject).map((a) => {
      const students = (a.student_details||[]).filter((s) => s.marks_obtained != null);
      const marks = students.map((s) => s.marks_obtained);
      const pcts  = students.map((s) => s.percentage??(a.max_marks?Math.round((s.marks_obtained/a.max_marks)*100):0));
      const maxMarks = students[0]?.max_marks ?? null;
      return {
        chapter: a.chapter||"Unknown",
        highest: marks.length ? Math.max(...marks) : null,
        lowest:  marks.length ? Math.min(...marks) : null,
        avgMark: marks.length ? parseFloat((marks.reduce((s,m)=>s+m,0)/marks.length).toFixed(1)) : 0,
        maxMarks, attempted: a.no_of_students_attempted||0, assigned: a.no_of_students_assigned||0,
        noData: marks.length === 0,
      };
    });
  }, [row3Subject, filteredReportData]);

  // ── Student Performance ────────────────────────────────────────────────────
  const studentPerformance = useMemo(() => {
    if (!filteredReportData?.length) return [];
    const map = {};
    filteredReportData.forEach((a) => {
      const sub = a.subject||"Unknown";
      const ch  = a.chapter||"Unknown";
      const maxM = a.student_details?.[0]?.max_marks ?? a.max_marks ?? null;
      (a.student_details||[]).forEach((s) => {
        if (s.marks_obtained == null && s.percentage == null) return;
        const name = s.student_name||s.name||"Unknown";
        const pct  = s.percentage??(maxM?Math.round((s.marks_obtained/maxM)*100):0);
        if (!map[name]) map[name] = { name, totalPct:0, count:0, subjects:{} };
        if (!map[name].subjects[sub]) map[name].subjects[sub] = { avgPct:0, count:0, chapters:[] };
        map[name].subjects[sub].chapters.push({ chapter:ch, marks:s.marks_obtained??0, maxMarks:s.max_marks??maxM??0, percentage:pct });
        map[name].subjects[sub].avgPct += pct;
        map[name].subjects[sub].count++;
        map[name].totalPct += pct;
        map[name].count++;
      });
    });
    return Object.values(map).map((st) => {
      const avgPct = st.count ? Math.round(st.totalPct/st.count) : 0;
      const subjectList = Object.entries(st.subjects).map(([sub, d]) => ({
        subject: sub, avgPct: Math.round(d.avgPct/d.count),
        chapters: d.chapters.sort((a,b) => a.percentage-b.percentage),
      }));
      return { ...st, avgPct, subjectList };
    }).sort((a,b) => b.avgPct-a.avgPct);
  }, [filteredReportData]);

  const topStudents  = useMemo(
    () => studentPerformance.filter((s) => s.avgPct >= 50).slice(0, 8),
    [studentPerformance]
  );
  const weakStudents = useMemo(() => {
    const topNames = new Set(topStudents.map((s) => s.name));
    const remaining = studentPerformance.filter((s) => !topNames.has(s.name));
    const below = remaining.filter((s) => s.avgPct < 50);
    return (below.length ? below : remaining.slice(-8)).slice(0,8).reverse();
  }, [studentPerformance, topStudents]);

  const selectedStudentData = useMemo(
    () => studentPerformance.find((s) => s.name === selectedStudent) ?? null,
    [selectedStudent, studentPerformance]);

  const selectedStudentSubjectChart = useMemo(() =>
    selectedStudentData ? selectedStudentData.subjectList : null,
    [selectedStudentData]);

  const selectedStudentChapterChart = useMemo(() => {
    if (!selectedStudentData || !studentSubjectFilter) return null;
    return selectedStudentData.subjectList.find((s) => s.subject === studentSubjectFilter)?.chapters ?? null;
  }, [selectedStudentData, studentSubjectFilter]);

  function NoReportAvailable({ mode }) {
    const periodText = {
      all: "for any period",
      today: "for today",
      yesterday: "for yesterday",
      week: "for the last 7 days",
      month: "for the last 30 days",
      range: "for the selected date range",
    }[mode] || "";

    return (
      <motion.div
        initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }}
        style={{
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          gap: 10, padding: "60px 20px", textAlign: "center",
        }}
      >
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.2">
          <path d="M3 3v18h18" /><path d="m7 16 4-4 4 4 4-4" />
        </svg>
        <div style={{ fontSize: 16, fontWeight: 700, color: "#334155" }}>No report available</div>
        <div style={{ fontSize: 13, color: "#94a3b8", maxWidth: 320 }}>
          There's no assignment data {periodText}. Try selecting a different period or check back after assigning tests.
        </div>
      </motion.div>
    );
  }

  return (
    <div className="dlg-wrapper">

      <motion.div className="dlg-page-header"
        initial={{ opacity:0, y:-10 }} animate={{ opacity:1, y:0 }} transition={{ duration:0.35 }}>
        <div>
          <h1 className="dlg-page-title">Report Board</h1>
          <p className="dlg-page-subtitle">Your learning analytics at a glance</p>
        </div>
          <div className="dlg-modal-actions">
                <button className="dlg-modal-confirm" onClick={()=>nav("/report-detailed-view")}>Detailed View</button>
              </div>
      </motion.div>

      <motion.div className="dlg-controls" initial={{ opacity:0 }} animate={{ opacity:1 }} transition={{ delay:0.1 }}>
        <PeriodTabs mode={mode} onChange={setMode} />
        {mode === "range" && (
          <div className="dlg-date-range">
            <input type="date" value={range.start}
              onChange={(e) => setRange((p) => ({ ...p, start: e.target.value }))} className="dlg-date-input" />
            <span className="dlg-date-range-sep">—</span>
            <input type="date" value={range.end}
              onChange={(e) => setRange((p) => ({ ...p, end: e.target.value }))} className="dlg-date-input" />
          </div>
        )}
        <div className="dlg-controls-right">
          <span className="dlg-bar-width-label">Bar width</span>
          <input type="range" min="10" max="60" step="2" value={barThickness}
            onChange={(e) => setBarThickness(Number(e.target.value))} className="dlg-range" />
          <span className="dlg-bar-width-value">{barThickness}px</span>
        </div>
      </motion.div>

      {subjectsAgg.length > 0 && (
        <motion.div className="dlg-stat-cards"
          initial={{ opacity:0, y:8 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.15 }}>
          {subjectsAgg.map((s) => (
            <StatCard key={s.subject} subject={s.subject} score={s.score} attempts={s.attempts}
              active={selectedSubject === s.subject}
              onClick={() => onSubjectClick([{ index: subjectsAgg.indexOf(s) }], subjectsAgg.map((x) => x.subject))}
            />
          ))}
          {selectedSubject && (
            <motion.button className="dlg-clear-btn" initial={{ opacity:0 }} animate={{ opacity:1 }}
              onClick={() => { setSelectedSubject(null); setGroup("All"); setSection1Filter(null); setSection2Filter(null); setSection3Filter(null); }}>
              ✕ Clear
            </motion.button>
          )}
        </motion.div>
      )}

      {filteredReportData?.length > 0 ? (
        <motion.div initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.5 }}>

          <div className="dlg-section-heading">
            <div className="dlg-section-dot" />
            <span className="dlg-section-meta"> Total assignments :
               {filteredReportData.length}
              {teacherSubject && (<>
                {" · "}<span style={{ color: pal(teacherSubject).solid, fontWeight:600 }}>{teacherSubject}</span>{" "}
                <button onClick={() => setTeacherSubject(null)}
                  style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8", fontSize:12 }}>✕</button>
              </>)}
            </span>
          </div>

          {/* ROW 1 */}
          <div className="dlg-grid mb-5">
            <ChartCard title="Students Attempted per Subject"
              subtitle={allZeroAttempted ? "⚠ No students have attempted any test yet"
                : "Click a bar to filter all charts below by that subject"}
              accent="#6366f1" delay={0.52} height={allZeroAttempted ? 160 : 200}>
              {teacherSubjectData.length === 0 ? <NoData /> : (<>
                {allZeroAttempted && <ZeroAttemptedBanner total={totalAssignedAcrossAll} />}
                <Bar
                  data={{
                    labels: teacherSubjectData.map((d) => d.subject.length>11 ? d.subject.slice(0,11)+"…" : d.subject),
                    datasets: [{ label:"Attempted", data: teacherSubjectData.map((d) => d.attempted),
                      backgroundColor: teacherSubjectData.map((d) => { const c=pal(d.subject).solid; return !teacherSubject||d.subject===teacherSubject?c:hex2rgba(c,0.22); }),
                      hoverBackgroundColor: teacherSubjectData.map((d) => pal(d.subject).solid),
                      borderRadius:6, borderSkipped:false, barThickness, minBarLength:12 }],
                  }}
                  options={mkOpts({
                    labelFn: (ctx) => { const r=teacherSubjectData[ctx.dataIndex]; return [`Attempted: ${r.attempted}`,`Assigned: ${r.assigned}`]; },
                    clickFn: (_,els) => { if(!els.length)return; const sub=teacherSubjectData[els[0].index]?.subject; setTeacherSubject(p=>p===sub?null:sub); },
                  })}
                />
              </>)}
            </ChartCard>

            <ChartCard title={teacherSubject ? `${teacherSubject} — Avg Score` : "All Chapters — Avg Score"}
              subtitle={teacherSubject ? `Chapters for ${teacherSubject} · Hover for details` : "Click a subject bar on the left"}
              accent="#6366f1" delay={0.56} height={200}
              locked={!teacherSubject} lockMsg="Click a subject bar on the left">
              {allChaptersAvgScore.length === 0 ? <NoData /> : (
                <Bar
                  data={{
                    labels: allChaptersAvgScore.map((d) => d.chapter.length>12?d.chapter.slice(0,12)+"…":d.chapter),
                    datasets: [{ label:"Avg Score %", data: allChaptersAvgScore.map((d) => d.avgScore),
                      backgroundColor: allChaptersAvgScore.map((d) => pal(d.subject).solid),
                      hoverBackgroundColor: allChaptersAvgScore.map((d) => pal(d.subject).solid),
                      borderRadius:6, borderSkipped:false, barThickness, minBarLength:12 }],
                  }}
                  options={mkOpts({ yLabel:"%", yMax:100,
                    labelFn: (ctx) => { const r=allChaptersAvgScore[ctx.dataIndex]; return [`Avg Score: ${r.avgScore}%`,`Attempted: ${r.attempted}/${r.assigned}`]; },
                  })}
                />
              )}
            </ChartCard>
          </div>

          {/* AI card */}
          <motion.div className="dlg-ai-card dlg-full-row mb-5"
            initial={{ opacity:0, y:16 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.28 }}>
            <div className="dlg-ai-inner">
              <div className="dlg-ai-icon">✦</div>
              <div className="dlg-ai-content">
                <div className="dlg-ai-title">AI Insight</div>
                <div className="dlg-ai-body">
                  {group==="All"
                    ? `Overall score ${overallScore}% across ${subjectsAgg.length} subject${subjectsAgg.length!==1?"s":""}. ${overallScore>=70?"Great progress! Keep the momentum going.":"Consistent daily practice will help push scores higher."}`
                    : `${group} score is ${selectedScore}%. Focus on weaker topics and reduce time on areas already mastered.`}
                </div>
              </div>
              <motion.button className="dlg-ai-cta" whileHover={{ scale:1.04 }} whileTap={{ scale:0.97 }}
                onClick={() => setShowCTAConfirm(true)}>Explore Course →</motion.button>
            </div>
          </motion.div>

          {/* ROW 2 */}
          <div className="dlg-grid" style={{ marginTop:0 }}>
            <ChartCard title={teacherSubject ? `${teacherSubject} — Avg Marks` : "All Chapters — Avg Marks"}
              subtitle="Click a bar to view score distribution on the right"
              accent="#f59e0b" delay={0.6} height={200}>
              {allChaptersMarksData.length === 0 ? <NoData /> : (
                <Bar
                  data={{
                    labels: allChaptersMarksData.map((d) => d.chapter.length>12?d.chapter.slice(0,12)+"…":d.chapter),
                    datasets: [{ label:"Avg Marks", data: allChaptersMarksData.map((d) => d.avgMark),
                      backgroundColor: allChaptersMarksData.map((d) => { const c=pal(d.subject).solid; return d.noData?hex2rgba(c,0.25):c; }),
                      hoverBackgroundColor: allChaptersMarksData.map((d) => pal(d.subject).solid),
                      borderRadius:6, borderSkipped:false, barThickness, minBarLength:12 }],
                  }}
                  options={mkOpts({
                    labelFn: (ctx) => { const r=allChaptersMarksData[ctx.dataIndex]; return r.noData?[`No attempts yet`,`Assigned: ${r.assigned}`]:[`Avg Marks: ${r.avgMark}/${r.maxMarks??"?"}`,`Attempted: ${r.attempted}/${r.assigned}`]; },
                    clickFn: (_,els) => { if(!els.length)return; setSelectedChapterIdx(p=>p===els[0].index?null:els[0].index); },
                  })}
                />
              )}
            </ChartCard>

            <ChartCard title="Score Distribution"
              subtitle={selectedChapterData ? `"${selectedChapterData.chapter}" — students per score range` : "Click a chapter bar on the left"}
              accent={selectedChapterData?pal(selectedChapterData.subject).solid:"#f59e0b"}
              delay={0.64} height={200} locked={!selectedChapterData} lockMsg="Click any chapter bar on the left">
              {selectedChapterData && (
                <Bar
                  data={{
                    labels: SCORE_BUCKETS,
                    datasets: [{ label:"Students", data: histogramData,
                      backgroundColor: histogramData.map((c,i)=>c===0?BUCKET_COLORS_DIM[i]:BUCKET_COLORS[i]),
                      hoverBackgroundColor: BUCKET_COLORS,
                      borderRadius:6, borderSkipped:false, barThickness:Math.min(barThickness,32), minBarLength:12 }],
                  }}
                  options={mkOpts({ yMax: Math.max(...histogramData,1),
                    labelFn: (ctx) => { const c=histogramData[ctx.dataIndex]; const l=SCORE_BUCKETS[ctx.dataIndex]; return c===0?`No students scored ${l}%`:`${c} student${c!==1?"s":""} scored ${l}%`; },
                  })}
                />
              )}
            </ChartCard>
          </div>

          {/* ROW 3 */}
          <div className="dlg-section-heading" style={{ marginTop:28 }}>
            <div className="dlg-section-dot" style={{ background:"#10b981" }} />
            <h2 className="dlg-section-title">Chapter Score Range</h2>
            <span className="dlg-section-meta">highest & lowest marks per chapter</span>
          </div>
          <div className="dlg-grid">
            <ChartCard title="Subjects"
              subtitle={teacherSubject ? `Showing chapters for ${teacherSubject}` : "Click a subject to view chapter-wise ranges"}
              accent="#10b981" delay={0.68} height={200}>
              {row3SubjectList.length === 0 ? <NoData /> : (
                <Bar
                  data={{
                    labels: row3SubjectList.map((d) => d.subject.length>11?d.subject.slice(0,11)+"…":d.subject),
                    datasets: [{ label:"Chapters", data: row3SubjectList.map((d) => d.chapters),
                      backgroundColor: row3SubjectList.map((d) => { const c=pal(d.subject).solid; return !row3Subject||d.subject===row3Subject?c:hex2rgba(c,0.25); }),
                      hoverBackgroundColor: row3SubjectList.map((d) => pal(d.subject).solid),
                      borderRadius:6, borderSkipped:false, barThickness, minBarLength:12 }],
                  }}
                  options={mkOpts({
                    labelFn: (ctx) => { const r=row3SubjectList[ctx.dataIndex]; return [`Attempted: ${r.attempted}`]; },
                    clickFn: (_,els) => { if(!els.length)return; const sub=row3SubjectList[els[0].index]?.subject; setRow3Subject(p=>p===sub?null:sub); setTeacherSubject(p=>p===sub?null:sub); },
                  })}
                />
              )}
            </ChartCard>

            <ChartCard title="Chapter Score Range"
              subtitle={row3Subject ? `${row3Subject} — hover for highest & lowest score` : "Click a subject on the left"}
              accent={row3Subject?pal(row3Subject).solid:"#10b981"} delay={0.72} height={200}
              locked={!row3Subject} lockMsg="Click a subject on the left">
              {row3ChapterList.length === 0 ? <NoData /> : (
                <Bar
                  data={{
                    labels: row3ChapterList.map((d) => d.chapter.length>14?d.chapter.slice(0,14)+"…":d.chapter),
                    datasets: [{ label:"Avg Marks", data: row3ChapterList.map((d) => d.avgMark),
                      backgroundColor: row3ChapterList.map((d) => { const c=row3Subject?pal(row3Subject).solid:"#10b981"; return d.noData?hex2rgba(c,0.2):c; }),
                      hoverBackgroundColor: row3ChapterList.map(()=>row3Subject?pal(row3Subject).solid:"#10b981"),
                      borderRadius:6, borderSkipped:false, barThickness, minBarLength:12 }],
                  }}
                  options={mkOpts({
                    labelFn: (ctx) => { const r=row3ChapterList[ctx.dataIndex]; return r.noData?[`No attempts yet`,`Assigned: ${r.assigned}`]:[`Highest: ${r.highest}`,`Lowest: ${r.lowest}`,`Avg: ${r.avgMark}`]; },
                  })}
                />
              )}
            </ChartCard>
          </div>

          {/* ═══ STUDENT PERFORMANCE INTELLIGENCE ═══ */}
          {studentPerformance.length > 0 && (<>
            <div className="dlg-section-heading" style={{ marginTop:32 }}>
              <div className="dlg-section-dot" style={{ background:"#f59e0b" }} />
              <h2 className="dlg-section-title">Student Performance</h2>
              <span className="dlg-section-meta">
                {studentPerformance.length} student{studentPerformance.length!==1?"s":""}
                {" · "}Click a name to drill down
                {selectedStudent && (<>
                  {" · "}<span style={{ color:"#2563eb", fontWeight:600 }}>{selectedStudent}</span>{" "}
                  <button onClick={()=>{ setSelectedStudent(null); setStudentSubjectFilter(null); }}
                    style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8", fontSize:12 }}>✕</button>
                </>)}
              </span>
            </div>

            {/* ROW 4 — Top Performers · Needs Attention */}
            <div className="dlg-grid">
              <ChartCard title="🏆 Top Performers"
                subtitle={`Top ${topStudents.length} students by average score · Click to see breakdown`}
                accent="#059669" delay={0.76}
                height={Math.max(topStudents.length * 46 + 16, 220)}>
                {topStudents.length === 0 ? <NoData /> : (
                  <div style={{ overflowY:"auto", height:"100%", paddingRight:4 }}>
                    {topStudents.map((st, i) => (
                      <StudentRow key={st.name} rank={i+1} name={st.name} avgPct={st.avgPct} isTop
                        isSelected={selectedStudent===st.name}
                        onClick={()=>{ setSelectedStudent(p=>p===st.name?null:st.name); setStudentSubjectFilter(null); }} />
                    ))}
                  </div>
                )}
              </ChartCard>

              <ChartCard title="⚠️ Needs Attention"
                subtitle={weakStudents.length === 0 ? "All students scoring above 50%!" : `${weakStudents.length} student${weakStudents.length!==1?"s":""} scoring below 50% · Click to investigate`}
                accent="#ef4444" delay={0.8}
                height={Math.max(weakStudents.length * 46 + 16, 220)}>
                {weakStudents.length === 0 ? (
                  <div className="dlg-no-data">
                    <span style={{ fontSize:28 }}>🎉</span>
                    <span className="dlg-no-data-text" style={{ color:"#059669" }}>All students above 50%!</span>
                  </div>
                ) : (
                  <div style={{ overflowY:"auto", height:"100%", paddingRight:4 }}>
                    {weakStudents.map((st, i) => (
                      <StudentRow key={st.name} rank={studentPerformance.length-i} name={st.name} avgPct={st.avgPct} isTop={false}
                        isSelected={selectedStudent===st.name}
                        onClick={()=>{ setSelectedStudent(p=>p===st.name?null:st.name); setStudentSubjectFilter(null); }} />
                    ))}
                  </div>
                )}
              </ChartCard>
            </div>

            {/* ROW 5 — Student Subject Scores · Chapter Marks Drill-down */}
            <div className="dlg-grid" style={{ marginTop:16 }}>
              <ChartCard
                title={selectedStudent ? `${selectedStudent} — Subject Scores` : "Student Subject Breakdown"}
                subtitle={selectedStudent ? "Average % per subject · Click a bar to see chapter marks on the right" : "Click any student above to view subject-wise scores"}
                accent="#2563eb" delay={0.84} height={220}
                locked={!selectedStudentData} lockMsg="Click a student in the lists above">
                {selectedStudentSubjectChart && selectedStudentSubjectChart.length > 0 && (
                  <Bar
                    data={{
                      labels: selectedStudentSubjectChart.map((d) => d.subject),
                      datasets: [{ data: selectedStudentSubjectChart.map((d) => d.avgPct),
                        backgroundColor: selectedStudentSubjectChart.map((d) => { const c=pal(d.subject).solid; return !studentSubjectFilter||studentSubjectFilter===d.subject?c:hex2rgba(c,0.25); }),
                        hoverBackgroundColor: selectedStudentSubjectChart.map((d) => pal(d.subject).solid),
                        borderRadius:6, borderSkipped:false, barThickness:Math.min(barThickness,40), minBarLength:12 }],
                    }}
                    options={mkHorizOpts({
                      labelFn: (ctx) => { const d=selectedStudentSubjectChart[ctx.dataIndex]; return [`${d.subject}: ${d.avgPct}%`]; },
                      clickFn: (_,els) => { if(!els.length)return; const sub=selectedStudentSubjectChart[els[0].index]?.subject; setStudentSubjectFilter(p=>p===sub?null:sub); },
                    })}
                  />
                )}
              </ChartCard>

              <ChartCard
                title={studentSubjectFilter ? `${selectedStudent} — ${studentSubjectFilter} Chapters` : "Chapter-wise Marks"}
                subtitle={studentSubjectFilter ? `Score per chapter · Green ≥75% · Blue ≥50% · Amber ≥35% · Red <35%` : "Click a subject bar on the left to see chapter-level marks"}
                accent={studentSubjectFilter?pal(studentSubjectFilter).solid:"#2563eb"}
                delay={0.88} height={220}
                locked={!studentSubjectFilter} lockMsg="Click a subject bar on the left">
                {selectedStudentChapterChart && selectedStudentChapterChart.length > 0 && (
                  <Bar
                    data={{
                      labels: selectedStudentChapterChart.map((d) => d.chapter.length>16?d.chapter.slice(0,16)+"…":d.chapter),
                      datasets: [{ data: selectedStudentChapterChart.map((d) => d.percentage),
                        backgroundColor: selectedStudentChapterChart.map((d) =>
                          d.percentage>=75?"#059669":d.percentage>=50?"#0891b2":d.percentage>=35?"#d97706":"#ef4444"),
                        hoverBackgroundColor: selectedStudentChapterChart.map(()=>studentSubjectFilter?pal(studentSubjectFilter).solid:"#2563eb"),
                        borderRadius:6, borderSkipped:false, barThickness:Math.min(barThickness,36), minBarLength:12 }],
                    }}
                    options={mkHorizOpts({
                      labelFn: (ctx) => { const d=selectedStudentChapterChart[ctx.dataIndex]; return [`${d.chapter}`,`Marks: ${d.marks}/${d.maxMarks||"?"} (${d.percentage}%)`]; },
                    })}
                  />
                )}
              </ChartCard>
            </div>
          </>)}

        </motion.div>) : <NoReportAvailable mode={mode} />
      }

      <AnimatePresence>
        {showCTAConfirm && (
          <motion.div className="dlg-modal-backdrop"
            initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }}
            onClick={() => setShowCTAConfirm(false)}>
            <motion.div className="dlg-modal-box"
              initial={{ scale:0.88, y:20 }} animate={{ scale:1, y:0 }} exit={{ scale:0.88, y:20 }}
              onClick={(e) => e.stopPropagation()}>
              <div className="dlg-modal-title">Ready to start?</div>
              <p className="dlg-modal-body">Open personalised course suggestions for <strong style={{ color:"#1e293b" }}>{group}</strong>.</p>
              <div className="dlg-modal-actions">
                <button className="dlg-modal-confirm" onClick={confirmCTA}>Confirm</button>
                <button className="dlg-modal-cancel" onClick={() => setShowCTAConfirm(false)}>Cancel</button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <SuggestionModal open={modalOpen} title={modalContent.title} onClose={() => setModalOpen(false)}>
        {modalContent.body}
      </SuggestionModal>
      <Loader show={loading} />
    </div>
  );
}